import { Version } from '@platform/version/version';

export const PLATFORM_VERSION = new Version('18.0.0').full;
